import { EntityHandler, EntityListResult, SectionHandlerGroup, FormSectionHandler } from '../entity.handler';
import { IKuiTableCol } from 'app/key-ui';
import { Injectable } from '@angular/core';
import { FuelCardResponse, FuelCardCreateRequest, FuelCardUpdateRequest } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { EnumToComboValues, GridColumnHelper } from '../utils';
import { FuelCardDetailsSectionHandler } from './details.section';
import { CustomFieldsSectionHandler } from '../shared/info.section';
import { ICONS } from '../icons';
import { RegisterEntityHandler } from '../../entities';
import { FuelCardLinkedSectionHandler } from './linked.section';

@RegisterEntityHandler('fuelcard')
@Injectable()
export class FuelCardHandler extends EntityHandler<FuelCardResponse> {

    constructor(
        admin: AdminEditorService
    ) {
        super(admin);
    }

    states = ['inactive', 'active', 'suspended', 'deleted'];

    listEntities(ownerId: string, offset: number, limit: number, sort: string, filter: string): Promise<EntityListResult> {
        return this.admin.getCached(`listFuelCards/${ownerId}/${offset}/${limit}/${sort}/${filter}`, api => api.entities.listFuelCards(ownerId, offset, limit, sort, filter), 3).then(response => ({
            ...response,
            type: 'fuelcard',
            title: this.admin.i18n.instant('ADMIN.ENTITIES.FUELCARDS'),
        }));
    }

    getEntity(id: string): Promise<FuelCardResponse> {
        return this.admin.getCached(`getFuelCard/${id}`, api => api.entities.getFuelCard(id), 10);
    }

    createEntity(ownerId: string, entity: FuelCardCreateRequest): Promise<FuelCardResponse> {
        entity.ownerId = ownerId;
        return this.admin.applyUpdate(api => api.entities.createFuelCard(entity));
    }

    setEntityState(entity: any, state: string): Promise<any> {
        return this.admin.applyUpdate(api => api.entities.updateFuelCard(entity.id, { state: state as any }));
    }   

    getGridColumns(ownerId: string): Promise<IKuiTableCol[]> {

        return this.admin.getCached(`getClient/${ownerId}`, api => api.accounts.getClient(ownerId), 60).then(client => {

            const grid = new GridColumnHelper(this.admin.i18n, 'ADMIN.EDITORS.FUELCARD.COLUMNS');

            const columns: IKuiTableCol[] = [
                grid.IconTextColumn('name', 'SERIAL_NUMBER', ICONS.fuelcard),
                grid.TextColumn('brandName', 'BRAND_NAME', 120),
                grid.TextColumn('embossedName', 'EMBOSSED_NAME', 150),
                grid.TextColumn('expiryDate', 'EXPIRY_DATE', 150),
                grid.ComboColumn('state', 'STATE', EnumToComboValues(this.admin.i18n, 'ADMIN.STATES', this.states, ['deleted']), 80),
                grid.TextColumn('description', 'DESCRIPTION'),
                grid.IdNameTextColumn('asset', 'ASSET', 120),
            ];

            (client.customFields['fuelcard'] || []).forEach(customField => {
                columns.push({
                    ...grid.TextColumn(`fields.${customField.id}`, customField.title, 100),
                    format: (_col, row) => {
                        return row.fields && row.fields[customField.id];
                    },
                });
            });

            columns.push(grid.TimeAgoColumn('modifiedDate', 'MODIFIED'));
            return columns;
        });

    }

    getEditorSections(ownerId: string, _entity: any): Promise<SectionHandlerGroup<FuelCardResponse>[]> {
        return Promise.resolve([{
            name: this.admin.i18n.instant('ADMIN.EDITOR.INFORMATION'),
            sections: [
                new FuelCardDetailsSectionHandler(this.admin, ownerId),
                new CustomFieldsSectionHandler<FuelCardResponse>(this.admin, ownerId, 'fuelcard'),
                new FuelCardLinkedSectionHandler(this.admin, ownerId),
            ],
        }]);
    }

    getCreationSections(ownerId: string): Promise<{ entityType: string, entity: FuelCardUpdateRequest, sections: FormSectionHandler<FuelCardResponse, any>[] }> {
        return Promise.resolve({
            entityType: 'fuelcard',
            entity: {}, // set up some defaults if you want
            sections: [
                new FuelCardDetailsSectionHandler(this.admin, ownerId),
                // new CustomFieldsSectionHandler<FuelCardResponse>(this.admin, ownerId, 'fuelcard'),
            ],
        });
    }

}













